import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE } from "../constants";
export function transformFlatToNested(flatData) {
    const nested = {};
    Object.entries(flatData).forEach(([key, value]) => {
        const [namespace, ...keyParts] = key.split(":");
        const actualKey = keyParts.join(":");
        if (namespace && actualKey) {
            if (!nested[namespace]) {
                nested[namespace] = {};
            }
            nested[namespace][actualKey] = value;
        }
    });
    return nested;
}
// Returns true when the incoming translations introduce a new key or change an existing value for the given language+namespace. Returns false when the bundle already contains identical values for every incoming key, so callers can skip the write and avoid a spurious "added" store event that would cause unnecessary React re-renders.
const hasBundleChanged = ({ language, namespace, translations, }) => {
    const existingBundle = i18n.getResourceBundle(language, namespace);
    if (!existingBundle)
        return true;
    return Object.entries(translations).some(([translationKey, translationValue]) => existingBundle[translationKey] !== translationValue);
};
class I18nEngine {
    initialized = false;
    init({ language = DEFAULT_LANGUAGE, missingKeyHandler, } = {}) {
        if (this.initialized) {
            if (missingKeyHandler) {
                i18n.options.saveMissing = true;
                i18n.options.missingKeyHandler = missingKeyHandler;
            }
            return;
        }
        void i18n.use(initReactI18next).init({
            lng: language,
            fallbackLng: DEFAULT_LANGUAGE,
            interpolation: {
                escapeValue: false,
            },
            compatibilityJSON: "v4",
            saveMissing: !!missingKeyHandler,
            missingKeyHandler,
            react: {
                bindI18nStore: "added",
            },
        });
        this.initialized = true;
    }
    addFlatResources(language, flatData) {
        const nestedResources = transformFlatToNested(flatData);
        Object.entries(nestedResources).forEach(([namespace, translations]) => {
            if (!hasBundleChanged({ language, namespace, translations }))
                return;
            i18n.addResourceBundle(language, namespace, translations, true, true);
        });
    }
    removeLanguageBundles(language) {
        const namespaces = Object.keys(i18n.store?.data[language] || {});
        namespaces.forEach((namespace) => {
            i18n.removeResourceBundle(language, namespace);
        });
    }
    getLoadedLanguages() {
        return Object.keys(i18n.store?.data ?? {});
    }
    async changeLanguage(language) {
        await i18n.changeLanguage(language);
    }
    getCurrentLanguage() {
        return i18n.language;
    }
    // eslint-disable-next-line id-length -- Standard i18n API convention; renaming would confuse consumers familiar with i18next.
    t(key, options) {
        // eslint-disable-next-line custom/no-dynamic-i18n-key -- Low-level i18next passthrough; callers must pass literal namespace:key strings so static extractors see them at their call sites.
        return i18n.t(key, options);
    }
}
export const i18nEngine = new I18nEngine();
